/* eslint-disable security/detect-object-injection */
import React, { useContext } from 'react';
import ApplicationContext from '../../context/ApplicationContext';
import './styles.css';
import RequiredField from '../../components/RequiredField';
import { motion } from 'framer-motion';
import { requiredLanguageContent } from '../../components/RequiredField/requiredLanguageContent';

function BannerImage() {
    const { facilityData, currentPage, selectedLanguage } = useContext(ApplicationContext);
    
    return (
        <div className={`${currentPage === 'nameVerify' || currentPage === 'dobVerify' ? 'no-margin' : ''} image-container`}>
            {currentPage === 'nameVerify' && <span className='flex mb-1'>
                <RequiredField />
                <p className={`text-gray text-sm font-normal ml-2 ${selectedLanguage === 'ar' ? 'dir-rtl' : ''}`}> {requiredLanguageContent['required'][selectedLanguage]}</p>
            </span>}
            <motion.img
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                src={facilityData.facility_banner || '/images/frame.jpg'}
                alt="banner"
                className="responsive-image rounded-b-[12px]"
            />
        </div>
    );
}

export default BannerImage;